<template>
  <div class="padded">

      <h3>{{rowData.actionType}} | <b :class="'text-' + approvalType(rowData.status)">{{rowData.status}}</b> | {{rowData.siteName}} - {{rowData.partyName}}</h3>

      <el-timeline>

      <el-timeline-item v-for="step in timeline" :key="step.id" :timestamp="'Last Update: ' + formatDateTime(step.updated_at)" placement="top">
        <el-card>
          <h4><i :class="step.stepIcon">&nbsp;</i>{{step.stepName}}</h4>
          <html-input v-if="step.remarks" v-model="step.remarks" disabled no-form />
          <div v-if="step.stepNo == 1 && rowData.remarks">
            <html-input v-if="rowData.remarks" v-model="rowData.remarks" disabled no-form />
          </div>

          <el-row v-if="hasFiles(step.stepNo, step.partyNo)" :gutter="24">

            <el-table :data="stepFiles(step.stepNo, step.partyNo)">

              <el-table-column prop="title" label="File Type" />
              <el-table-column prop="name" label="File Name" />
              <el-table-column prop="upload_at" label="Uploaded At" />
              <el-table-column prop="upload_by" label="Uploaded By" />
              <el-table-column prop="lastDownload_at" label="Last Download At" />
              <el-table-column prop="lastDownload_by" label="Last Download By" />

            </el-table>
            <center><small class="text-primary">Total Uploads <b>{{step.stepFiles}}</b></small></center>

          </el-row>

          <el-row v-if="step.step_completed || step.step_approved" :gutter="24">

            <el-col v-if="step.step_approved" :span="step.step_completed ? 12 : 24">
              <el-alert :type="approvalType(step.approvedStatus)" show-icon :closable="false" center
              :title="step.approvedStatus"
              :description="'On ' + formatDateTime(step.step_approved_at) + (step.step_approved_by ? ' by ' + step.step_approved_by : '')"
               />
            </el-col>

            <el-col v-if="step.step_completed" :span="step.step_approved ? 12 : 24">
              <el-alert type="info" show-icon :closable="false" center
              title="Completed"
              :description="'On ' + formatDateTime(step.step_completed_at) + (step.step_completed_by ? ' by ' + step.step_completed_by : '')"
               />
            </el-col>

          </el-row>

        </el-card>
      </el-timeline-item>

    </el-timeline>

    <el-pagination
        class="pull-right"
        layout="prev, pager, next"
        hide-on-single-page
        :total="timeline.length">
     </el-pagination>
  </div>
</template>



<script>

import SiteMixins from '@/mixins/SiteMixins'

export default {

  mixins: [SiteMixins],

  props: {

    rowData: {
      type: Object,
      required: true
    }

  },

  methods: {

    fillFiles (data) {
      this.files = data
    },


    fillTimeline (data) {
      this.timeline = data
    },


    approvalType (status) {
      let type = 'info1'

      if (status) {

        switch (status) {
          case 'Approved':
            type = 'success'
            break

          case 'Conditional':
            type = 'warning'
            break

          case 'Rejected':
            type = 'danger'
            break

        }
      }

      return type
    },


    hasFiles (step, party) {
      return this.isArray(this.files) && this.stepFiles(step, party).length > 0 ? true : false
    },


    stepFiles (step, party) {
      if (this.isArray(this.files)) {

        var stepPartyFiles = []

        for (let i = 0; i < this.files.length; i++) {

          if (this.files[i].step === step && this.files[i].partyNo === party) {
            stepPartyFiles.push(this.files[i])
          }

        }  // for

        return stepPartyFiles

      }

      return null
    }

  },



  data () {

    return {
      timeline: [],
      files: []
    }

  },



  created () {
    this.fetchData('/report/requests/' + this.rowData.action_id + '/' + this.rowData.partyNo, this.fillTimeline)
    this.fetchData('/files/site/' + this.rowData.site_id +
    '/' + this.rowData.actionType.toLowerCase() +
    '/' + this.rowData.action_id +
    '/null' +
    '/' + this.rowData.partyNo, this.fillFiles)
  }

}
</script>
